'use client'

import { trackEvent } from '@lib/tracking'
import { TrackingEvents } from '@lib/tracking/TrackingEvents'
import { useEffect, useState } from 'react'
import { useHandleFacetClick } from './Hooks/useHandleFacetClick.client'
import { useSearchFacetValues } from './Hooks/useSearchFacetValues'
import { RefinementSearchDropdown } from './MobileFilterOverlay/RefinementSearchDropdown'

const ATTRIBUTE_ALIAS = 'treatmentNamesWithAlternates'

export default function TreatmentFilterRefinementList({
  activeTreatmentLabel,
  inputClassName,
}: {
  activeTreatmentLabel?: string
  inputClassName?: string
}) {
  const [searchTerm, setSearchTerm] = useState('')
  const [treatments, setTreatments] = useState<string[]>([
    'Cognitive Behavioral Therapy',
    'Medication Management',
    'Group Therapy',
    'Psychotherapy',
    'Mindfulness-Based Therapy',
    'Exposure Therapy',
  ])

  const handleFacetClick = useHandleFacetClick()
  const searchFacetValues = useSearchFacetValues({
    attribute: ATTRIBUTE_ALIAS,
    setResults: setTreatments,
  })

  const [selectedTreatment, setSelectedTreatment] = useState<
    string | undefined
  >(activeTreatmentLabel ?? undefined)

  useEffect(() => {
    if (searchTerm) {
      searchFacetValues(searchTerm)
    }
  }, [searchTerm, searchFacetValues])

  return (
    <RefinementSearchDropdown
      inputClassName={inputClassName}
      onChange={setSearchTerm}
      onSelect={(item) => {
        handleFacetClick({
          facetType: 'treatment',
          selectedValue: selectedTreatment,
          setSelectedValue: setSelectedTreatment,
          value: item,
        })
        trackEvent(TrackingEvents.SEARCH_LANDER_TREATMENT_FILTER_CLICKED, {
          val: item,
        })
      }}
      placeholder={selectedTreatment ?? 'Type Treatment'}
      selectedItem={selectedTreatment}
      suggestions={treatments}
      value={searchTerm}
    />
  )
}
